import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { MenuService } from "../../services/menu/menu.service";
import { PricingService } from "../../services/pricing/pricing.service";
import { ItemDescriptionsService } from "app/services/item-descriptions/item-descriptions.service";
import * as _ from "lodash";

@Injectable()
export class MenuStore {
  public menu = new Array();
  public menuSource = <BehaviorSubject<any[]>>new BehaviorSubject([]);

  public menuResult = new Array();
  public menuResultSource = <BehaviorSubject<any[]>>new BehaviorSubject([]);

  public itemDescriptions;

  constructor(
    private _http: Http,
    private _menuService: MenuService,
    private _pricingService: PricingService,
    private _itemDescriptionService: ItemDescriptionsService
  ) {
    this._itemDescriptionService.getAllItems().then(result => {
      this.itemDescriptions = result;
    });
  }

  public getMenu() {
    return this.menuResultSource.asObservable();
  }

  /**
   * Updates the observable menu for the components that
   * subscribe to them
   * @param {Menu} Array
   */
  public updateMenu(menu) {
    this.menuSource.next(menu);
    localStorage.setItem("menu", JSON.stringify(menu));
  }

  /**
   * Takes in the full menu from the pos system.
   * organizes, sorts, formats pricing, and removes unwanted items.
   * Updates the menu observable
   * @param {Array} Array
   * @return {Array} Array
   */
  public organizeMenu(menu) {
    console.log("full-menu:", menu);
    return this._removeItemsBySLU(menu).then((organizedMenu: any) => {
      return this._formatMenuItemPrices(organizedMenu).then((menu: any) => {
        menu = this._sortMenuByCategory(menu);
        console.log("sorted menu", menu);
        this.menuResultSource.next(menu);
        this.updateMenu(menu);
        return new Promise((resolve, reject) => {
          resolve(menu);
        });
      });
    });
  }

  /**
   * Takes in a menu array and updates the menu observable
   * and resorts the menu for the new descriptions and categories
   * @param {Array} arr
   */
  public attachMenuItemDescriptions(menu) {
    for (let i = 0; menu.length > i; i++) {
      // Attach Descriptions
      for (let k = 0; this.itemDescriptions.length > k; k++) {
        let description = this.itemDescriptions[k].description;
        let name = this.itemDescriptions[k].name;
        let category = this.itemDescriptions[k].category;
        let sluId = this.itemDescriptions[k].id;
        if (menu[i].id === sluId) {
          menu[i].description = description;
          menu[i].name = name;
          if (!category || category === "DEFAULT" || category === "") {
          } else {
            menu[i].category = category;
          }
        }
      }
      if (i === menu.length - 1) {
        menu = this._sortMenuByCategory(menu);
        this.menuResultSource.next(menu);
        this.updateMenu(menu);
        return new Promise((resolve, reject) => {
          resolve(menu);
        });
      }
    }
  }

  /**
   * Takes in a menu array and returns a new menu
   * with all of the formatted prices attached
   * @param {Array} arr
   * @return {Menu} array
   */
  private _formatMenuItemPrices(menu) {
    for (let i = 0; menu.length > i; i++) {
      let price = menu[i].price_per_unit;
      let output = this._pricingService.formatPrice(price);
      let newPrice = output;
      if (newPrice !== undefined) {
        menu[i].formatted_price = newPrice;
      }
      // this could be its own function, attachPrice
      for (let j = 0; menu[i]._embedded.price_levels.length > j; j++) {
        let price = menu[i]._embedded.price_levels[j].price_per_unit;
        let newPrice = this._pricingService.formatPrice(price);
        if (newPrice !== undefined) {
          menu[i]._embedded.price_levels[j].formatted_price = newPrice;
        }
      }
      if (i === menu.length - 1) {
        return new Promise((resolve, reject) => {
          resolve(menu);
        });
      }
    }
  }
  /**
   * Loops through the initial menu from the POS system and removes any
   * unwated item by SLU and attaches items to their correct categories
   * @param {Array} arr
   * @return {Menu} array
   */
  private _removeItemsBySLU(menu) {
    let organizedMenu = [];

    for (let i = 0; menu.length > i; i++) {
      let sluID = menu[i].id;
      // Check for taco items that are in Combo Category
      if (sluID === "55005" || sluID === "55006" || sluID === "55007") {
        menu[i].category = "TACOS";
      } // Remove Burrito W/MT & Straw Lemonade
      else if (sluID === "58030" || sluID === "60003") {
        // Check for fajita items that are in Favorites
      } else if (sluID === "52008" || sluID === "52017" || sluID === "52018" || sluID === "52013") {
        menu[i].category = "FAJITAS";
      } else if (
        sluID === "50004" ||
        sluID === "64018" ||
        sluID === "64009" ||
        sluID === "51013" ||
        sluID === "50002"
      ) {
        // Dont add the Potato Skins, Ceaser Salad, & Soup & Salad
      } else if (
        sluID === "55008" ||
        sluID === "59004" ||
        sluID === "59009" ||
        sluID === "59006" ||
        sluID === "59007" ||
        sluID === "59008"
      ) {
        // Don't Add Vday item, Birthday Flan, Choc Strawberry, Kid's Vanilla, Ice cream scoop
      } else if (sluID === "58014") {
      } else if (sluID === "54003" || sluID === "54002" || sluID === "54001" || sluID === "54004") {
        // Don't add the senior meals
      } else if (sluID === "58020" || sluID === "58021") {
        // Don't add the ala carte meat items
      } else if (sluID === "225008" || sluID === "225010" || sluID === "225011") {
        // Don't the taco wednesday, tuesday, and 3 tacos for 5 dollar items
      } else if (sluID === "64008") {
        // Dont add two enchiladas in lunch specials
      } else if (sluID === "57050") {
        // Don't add kids eat free
      } else if (sluID === "52026" || sluID === "52027" || sluID === "52028") {
        // Don't add Guajillo Salmon / Achiote Chicke / Rodrigo's Bowl because
        // they are only  being tested at the orange location.
      } else {
        let menuCatArr = menu[i]._embedded.menu_categories;
        let menuCat = this._getMenuCategory(menuCatArr);
        let desiredMenuCat = this._reassignDesiredCategories(menuCat);
        menu[i].category = desiredMenuCat;
      }
      this._pushDesiredItem(organizedMenu, menu[i]);

      if (i === menu.length - 1) {
        return new Promise((resolve, reject) => {
          resolve(organizedMenu);
        });
      }
    }
  }

  /**
   * After all the items have been updated and tweaked
   * the menu gets sorted in alphabetical order by category
   * @param {menu} array
   * @return {menu} array
   */
  private _sortMenuByCategory(menu) {
    return _.sortBy(menu, ["category"]);
  }

  /**
   * Takes in a menu array and returns a new menu
   * with all of the formatted prices attached
   * @param {Array} arr
   * @return {Menu} array
   */
  private _attachPrice(arr) {}

  /**
   * Takes in a menu category array and reassigns it to the desired
   * categories that show up on the front end of the site
   * @param {Array} arr
   * @return {Category Name} string
   */
  private _reassignDesiredCategories(category) {
    switch (category) {
      // Sides
      // case 'ROD SIDES':
      //   category = 'SIDES'
      // break;
      // case 'DJ SIDES':
      //   category = 'SIDES'
      // break;

      //Salads
      case "ROD SALADS":
        category = "SALADS";
        break;
      case "DJ SALADS":
        category = "SALADS";
        break;

      //Lunch Specials
      case "DJ LUNCH EXPRESS":
        category = "LUNCH SPECIALS";
        break;
      case "ROD LUNCH EXPRESS":
        category = "LUNCH SPECIALS";
        break;

      //Combos
      case "ROD COMBOS":
        category = "COMBOS";
        break;
      case "DJ COMBOS":
        category = "COMBOS";
        break;

      // APPS
      case "ROD APPS":
        category = "APPETIZERS";
        break;

      case "DJ APPS":
        category = "APPETIZERS";
        break;

      //BURRITOS
      case "DJ BURRITOS":
        category = "BURRITOS";
        break;

      case "ROD BURRITOS":
        category = "BURRITOS";
        break;

      // A LA CARTE
      // case "ROD A LA CARTE":
      //   category = "A LA CARTE";
      //   break;

      case "DJ A LA CARTE":
        category = "A LA CARTE";
        break;

      // DESSERTS
      case "DJ DESSERTS":
        category = "DESSERTS";
        break;

      case "ROD DESSERTS":
        category = "DESSERTS";
        break;

      //BEVERAGES
      case "BEVERAGES":
        category = "BEVERAGES";
        break;

      // BRUNCH
      // case 'ROD BRUNCH':
      //   category = 'BRUNCH'
      // break;

      // case 'DJ BRUNCH':
      //   category = 'BRUNCH'
      // break;

      // SPECIALS
      case "ROD SPECIALS":
        category = "SPECIALTIES";
        break;

      case "DJ SPECIALS":
        category = "SPECIALTIES";
        break;

      case "DJ SPECIALTIES":
        category = "SPECIALTIES";
        break;

      // FAVORITES
      case "ROD FAVORITES":
        category = "FAVORITES";
        break;

      case "DJ FAVORITES":
        category = "FAVORITES";
        break;

      case "DJ FAVORITES":
        category = "FAVORITES";
        break;

      default:
        break;
    }
    return category;
  }

  /**
   * Takes in a menu category array and reassigns it to the desired
   * categories that show up on the front end of the site
   * @param {Array} arr
   * @param {Array} Organzied Menu
   * @return {Array} Organized Menu
   */

  private _pushDesiredItem(organizedMenu, menuItem) {
    // Filter For Desired Categories
    // console.log('menuItem', menuItem);
    // console.log('organized menu', organizedMenu);

    switch (menuItem.category) {
      case "SALADS":
        organizedMenu.push(menuItem);
        break;
      // case "BEVERAGES":
      //   organizedMenu.push(menuItem);
      //   break;
      case "BURRITOS":
        organizedMenu.push(menuItem);
        break;
      case "FAVORITES":
        organizedMenu.push(menuItem);
        break;
      case "SPECIALTIES":
        organizedMenu.push(menuItem);
        break;
      case "DESSERTS":
        organizedMenu.push(menuItem);
        break;
      // case 'BRUNCH':
      //   organizedMenu.push(menuItem);
      // break;
      case "COMBOS":
        organizedMenu.push(menuItem);
        break;

      case "KIDS":
        organizedMenu.push(menuItem);
        break;
      // case 'FIESTA MENU':
      //   organizedMenu.push(menuItem);
      // break;
      case "A LA CARTE":
        organizedMenu.push(menuItem);
        break;
      case "LUNCH SPECIALS":
        organizedMenu.push(menuItem);
        break;
      case "TACOS":
        organizedMenu.push(menuItem);
        break;
      case "FAJITAS":
        organizedMenu.push(menuItem);
        break;
      case "APPETIZERS":
        organizedMenu.push(menuItem);
        // case 'Entree':
        // organizedMenu.push(menuItem);
        // case 'Appetizer':
        // organizedMenu.push(menuItem);
        break;
      default:
        break;
    }

    return organizedMenu;
  }

  /**
   * Takes in a menu category array
   * @param {Array} arr
   * @return {Category Name} string
   */
  private _getMenuCategory(arr) {
    return arr[0].name;
  }

  /**
   * Handles any errors that the service requests may get
   * @param {Error} object
   * @return {Server Error} Observable
   */
  private handleError(error) {
    console.error(error);
    if (error.status == 404) {
      // alert('Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file');
    }
    return Observable.throw(error.json().error || "Server error");
  }
}



// WEBPACK FOOTER //
// ./src/app/store/menu/menu.store.ts